import Palette from '@opsbase/lib-palette/Palette';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Swatch from '@opsbase/web-ui/Swatch';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
export function ViewReportKeyLine(props) {
    const { group, fullWidth = false } = props;
    return (React.createElement(Horizontal, { centered: true, style: { maxWidth: fullWidth ? '100%' : 400 }, gutter: true, key: group.id },
        React.createElement(Pane, { grow: true },
            React.createElement(Horizontal, { gutter: true, justify: 'flex-start' },
                React.createElement(Swatch, { color: (group === null || group === void 0 ? void 0 : group.color) || Palette.Black }),
                React.createElement(Text, { noWrap: true }, group.title)))));
}
export default ViewReportKeyLine;
